// store/index.js — Stag Fondation
// Version complète avec :
//   ✓ Événements (state, mutations, actions)
//   ✓ Actions manquantes : setAssociationFilter/Page, setFormationFilter/Page,
//                          setProjectFilter/Page, setContactPage
//   ✓ Bug corrigé : double slash apiUrl + '/public/events'
//   ✓ Bug corrigé : SET_EVENTS appelé avec la bonne structure

import { createStore } from 'vuex'
import axios from 'axios'

export default createStore({

  // ═══════════════════════════════════════════════════════════════════
  // STATE
  // ═══════════════════════════════════════════════════════════════════
  state: {
    // ── Config API ────────────────────────────────────────────────
    apiUrl:   'https://api.stagfondation.org/api/',
    imageUrl: 'https://api.stagfondation.org/',

    // ── Auth ──────────────────────────────────────────────────────
    token: localStorage.getItem('token') || null,
    user:  JSON.parse(localStorage.getItem('user')) || null,

    // ── UI ────────────────────────────────────────────────────────
    loading:      false,
    error:        null,
    toastMessage: '',

    // ── Articles publics ──────────────────────────────────────────
    articles:        [],
    featuredArticle: null,
    currentArticle:  null,
    popularArticles: [],
    latestArticles:  [],
    pagination: { current_page:1, last_page:1, per_page:12, total:0 },
    filters: {
      search:'', category:'', tag:'',
      sort_by:'published_at', sort_order:'desc'
    },
     reviews:         [],
  featuredReviews: [],
  reviewsPagination: { current_page:1, last_page:1, total:0, per_page:9 },
  reviewStats:     { total:0, pending:0, approved:0, rejected:0, featured:0, average_rating:0 },
  reviewFilters:   { search:'', status:'', source_type:'', sort_by:'created_at', sort_order:'desc' },
 
  homeStats: {
    graduates:       0,
    partners:        0,
    active_projects: 0,
    beneficiaries:   0,
    total_raised:    0,
    reviews_count:   0,
  },
  

    // ── Articles admin ────────────────────────────────────────────
    articlesAdmin: [],
    articlesAdminPagination: { current_page:1, last_page:1, per_page:15, total:0 },
    articlesAdminFilters: {
      search:'', status:'', category:'',
      sort_by:'created_at', sort_order:'desc'
    },
    articlesAdminStats: { total:0, published:0, draft:0, archived:0, views_total:0 },

    // ── Événements ────────────────────────────────────────────────
    events:       [],
    currentEvent: null,
    eventStats:   { total:0, published:0, upcoming:0, draft:0 },
    eventsPagination: { current_page:1, last_page:1, total:0, per_page:9 },
    eventsFilters:    { search:'', status:'', filter:'', category:'', page:1 },

    // ── Formations ────────────────────────────────────────────────
    formations:       [],
    currentFormation: null,
    formationsPagination: { current_page:1, last_page:1, per_page:15, total:0 },
    formationStats: { total:0, active:0, upcoming:0, complet:0, total_enrolled:0 },
    formationFilters: {
      search:'', level:'', status:'', category:'',
      sort_by:'created_at', sort_order:'desc'
    },

    // ── Inscriptions formations ───────────────────────────────────
    formationRegistrations: [],
    currentRegistration:    null,
    formationRegistrationsPagination: { current_page:1, last_page:1, per_page:15, total:0 },
    registrationStats: {
      total:0, en_attente:0, confirmés:0, annulés:0,
      terminés:0, capacite:0, places_restantes:0, taux_occupation:0
    },
    registrationFilters: {
      search:'', status:'', payment_status:'', date_from:'', date_to:'',
      sort_by:'registered_at', sort_order:'desc'
    },

    // ── Projets ───────────────────────────────────────────────────
    projects:       [],
    currentProject: null,
    featuredProject: null,
    relatedProjects: [],
    projectsPagination: { current_page:1, last_page:1, per_page:15, total:0 },
    projectStats: {
      total:0, actifs:0, planifiés:0, terminés:0,
      budget_total:0, beneficiaires_total:0
    },
    projectFilters: {
      search:'', status:'', category:'',
      sort_by:'created_at', sort_order:'desc'
    },

    // ── Associations ──────────────────────────────────────────────
    associations:        [],
    currentAssociation:  null,
    featuredAssociations:[],
    similarAssociations: [],
    associationCategories: [],
    associationsPagination: { current_page:1, last_page:1, per_page:15, total:0 },
    associationStats: { total:0, actives:0, en_attente:0, featured:0, total_projects:0 },
    associationFilters: {
      search:'', category:'', status:'',
      sort_by:'name', sort_order:'asc'
    },

    // ── Contacts ──────────────────────────────────────────────────
    contacts:        [],
    currentContact:  null,
    contactsPagination: { current_page:1, last_page:1, per_page:15, total:0 },
    contactStats: { total:0, nouveaux:0, en_cours:0, traites:0, non_lus:0, urgents:0 },
    contactFilters: {
      search:'', status:'', priority:'', assigned_to:'',
      sort_by:'created_at', sort_order:'desc'
    },

    // ── Dons ──────────────────────────────────────────────────────
    donations:        [],
    selectedDonation: null,
    donationsPagination: { current_page:1, last_page:1, per_page:15, total:0 },
    donationStats: {
      total_collected:0, total_count:0, average_donation:0,
      this_month:0, pending_count:0, by_project:[], by_month:[]
    },
    donationProjects: [],

    // ── Équipe ────────────────────────────────────────────────────
    teamMembers:       [],
    currentTeamMember: null,
    teamMembersPagination: { current_page:1, last_page:1, per_page:15, total:0 },
    teamMemberStats: { total:0, actifs:0, inactifs:0, featured:0, par_departement:[] },
    teamMemberDepartments: [],
    teamMemberFilters: {
      search:'', department:'', status:'', is_featured:'',
      sort_by:'order', sort_order:'asc'
    },

    // ── Activités récentes ────────────────────────────────────────
    recentActivities: [],
  },

  // ═══════════════════════════════════════════════════════════════════
  // GETTERS
  // ═══════════════════════════════════════════════════════════════════
  getters: {
    isAuthenticated: s => !!s.token,
    isAdmin:         s => s.user?.role === 1,
    authHeader:      s => ({ Authorization: `Bearer ${s.token}` }),

    filteredArticlesAdmin(state) {
      let filtered = [...state.articlesAdmin]
      const f = state.articlesAdminFilters
      if (f.search) {
        const q = f.search.toLowerCase()
        filtered = filtered.filter(a =>
          a.title?.toLowerCase().includes(q) ||
          a.content?.toLowerCase().includes(q) ||
          a.category?.toLowerCase().includes(q)
        )
      }
      if (f.status)   filtered = filtered.filter(a => a.status   === f.status)
      if (f.category) filtered = filtered.filter(a => a.category === f.category)
      filtered.sort((a, b) => {
        const dir = f.sort_order === 'asc' ? 1 : -1
        return a[f.sort_by] < b[f.sort_by] ? -dir : a[f.sort_by] > b[f.sort_by] ? dir : 0
      })
      return filtered
    },

    publishedArticles: s => s.articles.filter(a => a.status === 'published'),
    articlesByCategory: s => cat => s.articles.filter(a => a.category === cat && a.status === 'published'),
    regularArticles:    s => s.articles.filter(a => a.status === 'published' && !a.is_featured).slice(0, 9),
  },

  // ═══════════════════════════════════════════════════════════════════
  // MUTATIONS
  // ═══════════════════════════════════════════════════════════════════
  mutations: {

    // ── Auth ──────────────────────────────────────────────────────
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    },
    SET_USER(state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    CLEAR_AUTH(state) {
      state.token = null; state.user = null
      localStorage.removeItem('token'); localStorage.removeItem('user')
      delete axios.defaults.headers.common['Authorization']
    },

    // ── UI ────────────────────────────────────────────────────────
    SET_LOADING(state, v) { state.loading = v },
    SET_ERROR(state, v)   { state.error   = v },
    CLEAR_ERROR(state)    { state.error   = null },
    SET_TOAST(state, v)   { state.toastMessage = v },
    CLEAR_TOAST(state)    { state.toastMessage = '' },

    // ── Événements ────────────────────────────────────────────────
    /**
     * SET_EVENTS reçoit { data, meta, stats } depuis EventController
     * ou la réponse brute axios.data selon l'appelant.
     * On normalise ici pour accepter les deux formes.
     */
     SET_REVIEWS(state, { reviews, pagination, stats }) {
    state.reviews = reviews
    if (pagination) state.reviewsPagination = pagination
    if (stats)      state.reviewStats       = stats
  },
  SET_FEATURED_REVIEWS(state, reviews) { state.featuredReviews = reviews },
  ADD_REVIEW(state, review)            { state.reviews.unshift(review) },
  UPDATE_REVIEW(state, r) {
    const i = state.reviews.findIndex(x => x.id === r.id)
    if (i !== -1) state.reviews[i] = r
  },
  REMOVE_REVIEW(state, id) { state.reviews = state.reviews.filter(r => r.id !== id) },
  SET_REVIEW_STATS(state, s)        { state.reviewStats = s },
  SET_REVIEW_FILTER(state, {key, value}) { state.reviewFilters[key] = value },
  SET_HOME_STATS(state, stats)      { state.homeStats = { ...state.homeStats, ...stats } },
    SET_EVENTS(state, payload) {
      // Payload peut être { data, meta, stats } ou la réponse API brute
      if (Array.isArray(payload.data)) {
        state.events = payload.data
        if (payload.meta)  state.eventsPagination = payload.meta
        if (payload.stats) state.eventStats       = payload.stats
      } else if (payload.data?.data) {
        // Réponse Laravel paginée brute : payload = axios.data
        state.events = payload.data.data || payload.data
        state.eventsPagination = {
          current_page: payload.current_page || 1,
          last_page:    payload.last_page    || 1,
          total:        payload.total        || 0,
          per_page:     payload.per_page     || 9,
        }
        if (payload.stats) state.eventStats = payload.stats
      }
    },
    SET_CURRENT_EVENT(state, event)      { state.currentEvent = event },
    SET_EVENTS_FILTER(state, { key, value }) { state.eventsFilters[key] = value },
    RESET_EVENTS_FILTERS(state) {
      state.eventsFilters = { search:'', status:'', filter:'', category:'', page:1 }
    },

    // ── Articles publics ──────────────────────────────────────────
    SET_ARTICLES(state, { articles, pagination }) {
      state.articles  = articles
      state.pagination = { ...state.pagination, ...pagination }
    },
    SET_FEATURED_ARTICLE(state, a)  { state.featuredArticle  = a },
    SET_CURRENT_ARTICLE(state, a)   { state.currentArticle   = a },
    SET_POPULAR_ARTICLES(state, a)  { state.popularArticles  = a },
    SET_LATEST_ARTICLES(state, a)   { state.latestArticles   = a },
    UPDATE_ARTICLE_VIEWS(state, id) {
      const a = state.articles.find(x => x.id === id)
      if (a) a.views_count = (a.views_count || 0) + 1
    },
    SET_FILTER(state, { key, value }) { state.filters[key] = value },
    RESET_FILTERS(state) {
      state.filters = { search:'', category:'', tag:'', sort_by:'published_at', sort_order:'desc' }
    },
    SET_PAGE(state, page) { state.pagination.current_page = page },

    // ── Articles admin ────────────────────────────────────────────
    SET_ARTICLES_ADMIN(state, { articles, pagination }) {
      state.articlesAdmin           = articles
      state.articlesAdminPagination = { ...state.articlesAdminPagination, ...pagination }
    },
    ADD_ARTICLE_ADMIN(state, a)           { state.articlesAdmin.unshift(a) },
    UPDATE_ARTICLE_ADMIN(state, a)        { const i=state.articlesAdmin.findIndex(x=>x.id===a.id); if(i!==-1)state.articlesAdmin[i]=a },
    REMOVE_ARTICLE_ADMIN(state, id)       { state.articlesAdmin = state.articlesAdmin.filter(a=>a.id!==id) },
    SET_ARTICLES_ADMIN_STATS(state, s)    { state.articlesAdminStats = s },
    SET_ARTICLES_ADMIN_FILTER(state, {key,value}) { state.articlesAdminFilters[key] = value },
    SET_ARTICLES_ADMIN_PAGE(state, page)  { state.articlesAdminPagination.current_page = page },
    RESET_ARTICLES_ADMIN_FILTERS(state)   { state.articlesAdminFilters = { search:'', status:'', category:'', sort_by:'created_at', sort_order:'desc' } },

    // ── Formations ────────────────────────────────────────────────
    SET_FORMATIONS(state, { formations, pagination }) {
      state.formations           = formations
      state.formationsPagination = { ...state.formationsPagination, ...pagination }
    },
    SET_CURRENT_FORMATION(state, f)   { state.currentFormation = f },
    ADD_FORMATION(state, f)           { state.formations.unshift(f) },
    UPDATE_FORMATION(state, f)        { const i=state.formations.findIndex(x=>x.id===f.id); if(i!==-1)state.formations[i]=f },
    REMOVE_FORMATION(state, id)       { state.formations = state.formations.filter(f=>f.id!==id) },
    SET_FORMATION_STATS(state, s)     { state.formationStats = s },
    SET_FORMATION_FILTER(state, {key,value}) { state.formationFilters[key] = value },
    SET_FORMATION_PAGE(state, page)   { state.formationsPagination.current_page = page },

    // ── Inscriptions formations ───────────────────────────────────
    SET_FORMATION_REGISTRATIONS(state, { registrations, pagination, formation }) {
      state.formationRegistrations       = registrations
      state.currentFormation             = formation
      state.formationRegistrationsPagination = { ...state.formationRegistrationsPagination, ...pagination }
    },
    SET_CURRENT_REGISTRATION(state, r)   { state.currentRegistration = r },
    UPDATE_REGISTRATION(state, r)        { const i=state.formationRegistrations.findIndex(x=>x.id===r.id); if(i!==-1)state.formationRegistrations[i]=r },
    REMOVE_REGISTRATION(state, id)       { state.formationRegistrations = state.formationRegistrations.filter(r=>r.id!==id) },
    SET_REGISTRATION_STATS(state, s)     { state.registrationStats = s },
    SET_REGISTRATION_FILTER(state, {key,value}) { state.registrationFilters[key] = value },
    SET_REGISTRATION_PAGE(state, page)   { state.formationRegistrationsPagination.current_page = page },
    CLEAR_REGISTRATIONS(state)           { state.formationRegistrations=[]; state.currentRegistration=null; state.registrationStats=null },

    // ── Projets ───────────────────────────────────────────────────
    SET_PROJECTS(state, { projects, pagination }) {
      state.projects           = projects
      state.projectsPagination = { ...state.projectsPagination, ...pagination }
    },
    SET_CURRENT_PROJECT(state, p)     { state.currentProject  = p },
    SET_FEATURED_PROJECT(state, p)    { state.featuredProject  = p },
    ADD_PROJECT(state, p)             { state.projects.unshift(p) },
    UPDATE_PROJECT(state, p)          { const i=state.projects.findIndex(x=>x.id===p.id); if(i!==-1)state.projects[i]=p },
    REMOVE_PROJECT(state, id)         { state.projects = state.projects.filter(p=>p.id!==id) },
    SET_PROJECT_STATS(state, s)       { state.projectStats = s },
    SET_PROJECT_FILTER(state, {key,value}) { state.projectFilters[key] = value },
    SET_PROJECT_PAGE(state, page)     { state.projectsPagination.current_page = page },
    SET_RELATED_PROJECTS(state, p)    { state.relatedProjects = p },

    // ── Associations ──────────────────────────────────────────────
    SET_ASSOCIATIONS(state, { associations, pagination }) {
      state.associations           = associations
      state.associationsPagination = { ...state.associationsPagination, ...pagination }
    },
    SET_CURRENT_ASSOCIATION(state, a)    { state.currentAssociation  = a },
    SET_FEATURED_ASSOCIATIONS(state, a)  { state.featuredAssociations = a },
    SET_SIMILAR_ASSOCIATIONS(state, a)   { state.similarAssociations  = a },
    ADD_ASSOCIATION(state, a)            { state.associations.unshift(a) },
    UPDATE_ASSOCIATION(state, a)         { const i=state.associations.findIndex(x=>x.id===a.id); if(i!==-1)state.associations[i]=a },
    REMOVE_ASSOCIATION(state, id)        { state.associations = state.associations.filter(a=>a.id!==id) },
    SET_ASSOCIATION_STATS(state, s)      { state.associationStats = s },
    SET_ASSOCIATION_CATEGORIES(state, c) { state.associationCategories = c },
    SET_ASSOCIATION_FILTER(state, {key,value}) { state.associationFilters[key] = value },
    SET_ASSOCIATION_PAGE(state, page)    { state.associationsPagination.current_page = page },

    // ── Contacts ──────────────────────────────────────────────────
    SET_CONTACTS(state, { contacts, pagination }) {
      state.contacts           = contacts
      state.contactsPagination = { ...state.contactsPagination, ...pagination }
    },
    SET_CURRENT_CONTACT(state, c)    { state.currentContact = c },
    ADD_CONTACT(state, c)            { state.contacts.unshift(c) },
    UPDATE_CONTACT(state, c)         { const i=state.contacts.findIndex(x=>x.id===c.id); if(i!==-1)state.contacts[i]=c },
    REMOVE_CONTACT(state, id)        { state.contacts = state.contacts.filter(c=>c.id!==id) },
    SET_CONTACT_STATS(state, s)      { state.contactStats = s },
    SET_CONTACT_FILTER(state, {key,value}) { state.contactFilters[key] = value },
    SET_CONTACT_PAGE(state, page)    { state.contactsPagination.current_page = page },

    // ── Dons ──────────────────────────────────────────────────────
    SET_DONATIONS(state, { donations, pagination }) {
      state.donations           = donations
      state.donationsPagination = { ...state.donationsPagination, ...pagination }
    },
    ADD_DONATION(state, d)           { state.donations.unshift(d) },
    UPDATE_DONATION(state, d)        { const i=state.donations.findIndex(x=>x.id===d.id); if(i!==-1)state.donations[i]=d },
    REMOVE_DONATION(state, id)       { state.donations = state.donations.filter(d=>d.id!==id) },
    SET_DONATION_STATS(state, s)     { state.donationStats = s },
    SET_DONATION_PROJECTS(state, p)  { state.donationProjects = p },
    SET_SELECTED_DONATION(state, d)  { state.selectedDonation = d },
    UPDATE_DONATION_STATUS(state, {id,status}) {
      const d = state.donations.find(x=>x.id===id); if(d) d.status = status
    },

    // ── Équipe ────────────────────────────────────────────────────
    SET_TEAM_MEMBERS(state, { members, pagination }) {
      state.teamMembers           = members
      state.teamMembersPagination = { ...state.teamMembersPagination, ...pagination }
    },
    SET_CURRENT_TEAM_MEMBER(state, m)  { state.currentTeamMember = m },
    ADD_TEAM_MEMBER(state, m)          { state.teamMembers.unshift(m) },
    UPDATE_TEAM_MEMBER(state, m)       { const i=state.teamMembers.findIndex(x=>x.id===m.id); if(i!==-1)state.teamMembers[i]=m },
    REMOVE_TEAM_MEMBER(state, id)      { state.teamMembers = state.teamMembers.filter(m=>m.id!==id) },
    SET_TEAM_MEMBER_STATS(state, s)    { state.teamMemberStats = s },
    SET_TEAM_MEMBER_DEPARTMENTS(state,d){ state.teamMemberDepartments = d },
    SET_TEAM_MEMBER_FILTER(state,{key,value}){ state.teamMemberFilters[key] = value },
    SET_TEAM_MEMBER_PAGE(state, page)  { state.teamMembersPagination.current_page = page },
    RESET_TEAM_MEMBER_FILTERS(state)   {
      state.teamMemberFilters = { search:'', department:'', status:'', is_featured:'', sort_by:'order', sort_order:'asc' }
    },

    // ── Activités ─────────────────────────────────────────────────
    SET_RECENT_ACTIVITIES(state, a) { state.recentActivities = a },
  },

  // ═══════════════════════════════════════════════════════════════════
  // ACTIONS
  // ═══════════════════════════════════════════════════════════════════
  actions: {

    // ─── Auth ──────────────────────────────────────────────────────
    async login({ commit }, credentials) {
      commit('SET_LOADING', true); commit('CLEAR_ERROR')
      try {
        const { data } = await axios.post(`${this.state.apiUrl}admin/login`, credentials)
        commit('SET_TOKEN', data.token); commit('SET_USER', data.user)
        commit('SET_TOAST', 'Connexion réussie')
        return data
      } catch (e) {
        const msg = e.response?.data?.message || 'Erreur de connexion'
        commit('SET_ERROR', msg); commit('SET_TOAST', msg); throw e
      } finally { commit('SET_LOADING', false) }
    },

    async logout({ commit, getters }) {
      try { await axios.post(`${this.state.apiUrl}logout`, {}, { headers: getters.authHeader }) }
      catch {}
      finally { commit('CLEAR_AUTH'); commit('SET_TOAST', 'Déconnexion réussie') }
    },
async fetchFeaturedReviews({ commit, state }) {
  try {
    const { data } = await axios.get(`${state.apiUrl}public/reviews/featured`)
    commit('SET_FEATURED_REVIEWS', data.data)
    return data
  } catch (e) {
    console.error('fetchFeaturedReviews:', e)
  }
},
 
async fetchPublicReviews({ commit, state }, params = {}) {
  commit('SET_LOADING', true)
  try {
    const { data } = await axios.get(`${state.apiUrl}public/reviews`, {
      params: {
        page:        state.reviewsPagination.current_page,
        per_page:    state.reviewsPagination.per_page,
        source_type: state.reviewFilters.source_type,
        ...params,
      }
    })
    commit('SET_REVIEWS', {
      reviews:    data.data,
      pagination: data.meta,
    })
    return data
  } catch { } finally { commit('SET_LOADING', false) }
},
 
async submitReview({ commit, state }, reviewData) {
  commit('SET_LOADING', true)
  try {
    const { data } = await axios.post(`${state.apiUrl}public/reviews`, reviewData)
    commit('SET_TOAST', data.message)
    return data
  } catch (e) {
    const msg = e.response?.data?.message || 'Erreur lors de l\'envoi'
    commit('SET_ERROR', msg)
    commit('SET_TOAST', msg)
    throw e
  } finally {
    commit('SET_LOADING', false)
  }
},
 
// ── STATISTIQUES PAGE D'ACCUEIL ─────────────────────────────────────
 
async fetchHomeStats({ commit, state }) {
  try {
    const { data } = await axios.get(`${state.apiUrl}public/home-stats`)
    commit('SET_HOME_STATS', data.data)
    return data
  } catch (e) {
    console.error('fetchHomeStats:', e)
  }
},
 
// ── ADMIN ───────────────────────────────────────────────────────────
 
async fetchReviewsAdmin({ commit, state, getters }) {
  commit('SET_LOADING', true)
  try {
    const { data } = await axios.get(`${state.apiUrl}admin/reviews`, {
      headers: getters.authHeader,
      params: {
        page:        state.reviewsPagination.current_page,
        per_page:    state.reviewsPagination.per_page,
        ...state.reviewFilters,
      }
    })
    commit('SET_REVIEWS', {
      reviews:    data.data,
      pagination: data.meta,
      stats:      data.stats,
    })
    return data
  } catch (e) {
    commit('SET_ERROR', 'Erreur lors du chargement des avis')
  } finally {
    commit('SET_LOADING', false)
  }
},
 
async approveReview({ commit, state, getters }, id) {
  try {
    const { data } = await axios.patch(`${state.apiUrl}admin/reviews/${id}/approve`, {}, { headers: getters.authHeader })
    commit('UPDATE_REVIEW', data.data)
    commit('SET_TOAST', 'Avis approuvé et publié')
    return data
  } catch (e) { commit('SET_ERROR', 'Erreur') ; throw e }
},
 
async rejectReview({ commit, state, getters }, { id, note }) {
  try {
    const { data } = await axios.patch(`${state.apiUrl}admin/reviews/${id}/reject`, { note }, { headers: getters.authHeader })
    commit('UPDATE_REVIEW', data.data)
    commit('SET_TOAST', 'Avis rejeté')
    return data
  } catch (e) { commit('SET_ERROR', 'Erreur') ; throw e }
},
 
async toggleReviewFeatured({ commit, state, getters }, id) {
  try {
    const { data } = await axios.patch(`${state.apiUrl}admin/reviews/${id}/toggle-featured`, {}, { headers: getters.authHeader })
    commit('UPDATE_REVIEW', { id, is_featured: data.is_featured })
    commit('SET_TOAST', data.message)
    return data
  } catch (e) { commit('SET_ERROR', 'Erreur') ; throw e }
},
 
async updateReview({ commit, state, getters }, { id, payload }) {
  try {
    const { data } = await axios.patch(`${state.apiUrl}admin/reviews/${id}`, payload, { headers: getters.authHeader })
    commit('UPDATE_REVIEW', data.data)
    commit('SET_TOAST', 'Avis mis à jour')
    return data
  } catch (e) { commit('SET_ERROR', 'Erreur') ; throw e }
},
 
async deleteReview({ commit, state, getters }, id) {
  try {
    await axios.delete(`${state.apiUrl}admin/reviews/${id}delete`, { headers: getters.authHeader })
    commit('REMOVE_REVIEW', id)
    commit('SET_TOAST', 'Avis supprimé')
  } catch (e) { commit('SET_ERROR', 'Erreur suppression') ; throw e }
},
    // ─── ÉVÉNEMENTS ────────────────────────────────────────────────

    /**
     * Liste publique des événements.
     * CORRIGÉ : apiUrl termine par '/' → pas de slash en début de chemin.
     */
    async fetchEventsPublic({ commit, state }) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.get(`${state.apiUrl}public/events`, {
          params: state.eventsFilters
        })
        // data = { success, data:[], meta:{}, stats:{} }
        commit('SET_EVENTS', { data: data.data, meta: data.meta, stats: data.stats })
      } catch (e) {
        commit('SET_ERROR', 'Erreur lors du chargement des événements')
      } finally {
        commit('SET_LOADING', false)
      }
    },

    /**
     * Événement unique par slug (public).
     * CORRIGÉ : double slash supprimé.
     */
    async fetchEventBySlug({ commit, state }, slug) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.get(`${state.apiUrl}public/events/${slug}`)
        commit('SET_CURRENT_EVENT', data.data)
        return data
      } catch (e) {
        commit('SET_ERROR', 'Événement non trouvé'); throw e
      } finally {
        commit('SET_LOADING', false)
      }
    },

    /** Liste événements (admin). */
    async fetchEventsAdmin({ commit, state, getters }) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.get(`${state.apiUrl}admin/events`, {
          headers: getters.authHeader,
          params:  state.eventsFilters
        })
        commit('SET_EVENTS', { data: data.data, meta: data.meta, stats: data.stats })
      } catch (e) {
        commit('SET_ERROR', 'Erreur lors du chargement')
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async saveEventAdmin({ state, getters }, formData) {
      await axios.post(`${state.apiUrl}admin/events`, formData, {
        headers: { ...getters.authHeader, 'Content-Type': 'multipart/form-data' }
      })
    },

    async deleteEventAdmin({ state, getters }, id) {
      await axios.delete(`${state.apiUrl}admin/events/${id}`, { headers: getters.authHeader })
    },

    async registerToEvent({ state }, { eventId, formData }) {
      const { data } = await axios.post(`${state.apiUrl}public/events/${eventId}/register`, formData)
      return data
    },

    setEventsFilter({ commit }, payload) { commit('SET_EVENTS_FILTER', payload) },
    resetEventsFilters({ commit })        { commit('RESET_EVENTS_FILTERS') },

    // ─── ARTICLES PUBLICS ──────────────────────────────────────────
    async fetchPublicArticles({ commit, state }) {
      commit('SET_LOADING', true); commit('CLEAR_ERROR')
      try {
        const { data } = await axios.get(`${state.apiUrl}public/articles`, {
          params: {
            page:       state.pagination.current_page,
            per_page:   state.pagination.per_page,
            search:     state.filters.search,
            category:   state.filters.category,
            tag:        state.filters.tag,
            sort_by:    state.filters.sort_by,
            sort_order: state.filters.sort_order,
          }
        })
        commit('SET_ARTICLES', {
          articles:   data.data,
          pagination: { current_page:data.current_page, last_page:data.last_page, per_page:data.per_page, total:data.total }
        })
        const featured = data.data.find(a => a.is_featured)
        if (featured) commit('SET_FEATURED_ARTICLE', featured)
        return data
      } catch (e) {
        const msg = e.response?.data?.message || 'Erreur lors du chargement des articles'
        commit('SET_ERROR', msg); throw e
      } finally { commit('SET_LOADING', false) }
    },

    async fetchArticleBySlug({ commit, state }, slug) {
      commit('SET_LOADING', true); commit('CLEAR_ERROR')
      try {
        const { data } = await axios.get(`${state.apiUrl}public/articles/${slug}`)
        const article = data.data.article || data.data
        commit('SET_CURRENT_ARTICLE', article)
        commit('UPDATE_ARTICLE_VIEWS', article.id)
        return data
      } catch (e) {
        commit('SET_ERROR', e.response?.data?.message || 'Article non trouvé'); throw e
      } finally { commit('SET_LOADING', false) }
    },

    async fetchLatestArticles({ commit, state }) {
      try {
        const { data } = await axios.get(`${state.apiUrl}public/articles/latest`)
        commit('SET_LATEST_ARTICLES', data.data)
      } catch {}
    },

    async fetchPopularArticles({ commit, state }) {
      try {
        const { data } = await axios.get(`${state.apiUrl}public/articles/popular`)
        commit('SET_POPULAR_ARTICLES', data.data)
      } catch {}
    },

    setFilter({ commit, dispatch }, filter) { commit('SET_FILTER', filter); dispatch('fetchPublicArticles') },
    setPage({ commit, dispatch }, page)     { commit('SET_PAGE', page);     dispatch('fetchPublicArticles') },
    resetFilters({ commit, dispatch })      { commit('RESET_FILTERS');       dispatch('fetchPublicArticles') },

    // ─── ARTICLES ADMIN ────────────────────────────────────────────
    async fetchArticlesAdmin({ commit, state, getters }) {
      commit('SET_LOADING', true); commit('CLEAR_ERROR')
      try {
        const { data } = await axios.get(`${state.apiUrl}admin/articles`, {
          params: {
            page:       state.articlesAdminPagination.current_page,
            per_page:   state.articlesAdminPagination.per_page,
            ...state.articlesAdminFilters
          },
          headers: getters.authHeader
        })
        commit('SET_ARTICLES_ADMIN', {
          articles:   data.data,
          pagination: { current_page:data.current_page, last_page:data.last_page, per_page:data.per_page, total:data.total }
        })
        return data
      } catch (e) {
        const msg = e.response?.data?.message || 'Erreur lors du chargement des articles'
        commit('SET_ERROR', msg); commit('SET_TOAST', msg); throw e
      } finally { commit('SET_LOADING', false) }
    },

    async fetchArticleAdmin({ state, getters }, id) {
      const { data } = await axios.get(`${state.apiUrl}admin/articles/${id}`, { headers: getters.authHeader })
      return data
    },

    async saveArticleAdmin({ commit, state, getters }, formData) {
      commit('SET_LOADING', true); commit('CLEAR_ERROR')
      try {
        const id  = formData.get('id')
        const url = id ? `${state.apiUrl}admin/articles/${id}` : `${state.apiUrl}admin/articles`
        if (id) formData.append('_method', 'POST')
        const { data } = await axios.post(url, formData, {
          headers: { ...getters.authHeader, 'Content-Type': 'multipart/form-data' }
        })
        const article = data.data
        if (id) { commit('UPDATE_ARTICLE_ADMIN', article); commit('SET_TOAST', 'Article modifié') }
        else    { commit('ADD_ARTICLE_ADMIN',    article); commit('SET_TOAST', 'Article créé') }
        return article
      } catch (e) {
        const msg = e.response?.data?.message || 'Erreur lors de la sauvegarde'
        commit('SET_ERROR', msg); commit('SET_TOAST', msg); throw e
      } finally { commit('SET_LOADING', false) }
    },

    async deleteArticleAdmin({ commit, state, getters }, id) {
      commit('SET_LOADING', true)
      try {
        await axios.delete(`${state.apiUrl}admin/articles/${id}`, { headers: getters.authHeader })
        commit('REMOVE_ARTICLE_ADMIN', id); commit('SET_TOAST', 'Article supprimé')
      } catch (e) {
        const msg = e.response?.data?.message || 'Erreur lors de la suppression'
        commit('SET_ERROR', msg); commit('SET_TOAST', msg); throw e
      } finally { commit('SET_LOADING', false) }
    },

    async toggleArticleStatusAdmin({ dispatch }, { id, status }) {
      const fd = new FormData()
      fd.append('id', id)
      fd.append('status', status === 'published' ? 'draft' : 'published')
      await dispatch('saveArticleAdmin', fd)
    },

    async uploadArticleImage({ commit, state, getters }, file) {
      const fd = new FormData(); fd.append('image', file)
      const { data } = await axios.post(`${state.apiUrl}admin/upload`, fd, {
        headers: { ...getters.authHeader, 'Content-Type': 'multipart/form-data' }
      })
      return data.path
    },

    setArticlesAdminFilter({ commit, dispatch }, filter) {
      commit('SET_ARTICLES_ADMIN_FILTER', filter); commit('SET_ARTICLES_ADMIN_PAGE', 1); dispatch('fetchArticlesAdmin')
    },
    setArticlesAdminPage({ commit, dispatch }, page) {
      commit('SET_ARTICLES_ADMIN_PAGE', page); dispatch('fetchArticlesAdmin')
    },
    resetArticlesAdminFilters({ commit, dispatch }) {
      commit('RESET_ARTICLES_ADMIN_FILTERS'); commit('SET_ARTICLES_ADMIN_PAGE', 1); dispatch('fetchArticlesAdmin')
    },

    // ─── FORMATIONS ADMIN ──────────────────────────────────────────
    async fetchFormations({ commit, state, getters }) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.get(`${state.apiUrl}admin/formations`, {
          headers: getters.authHeader,
          params: {
            page:       state.formationsPagination.current_page,
            per_page:   state.formationsPagination.per_page,
            ...state.formationFilters
          }
        })
        commit('SET_FORMATIONS', {
          formations: data.data,
          pagination: { current_page:data.current_page, last_page:data.last_page, per_page:data.per_page, total:data.total }
        })
        return data
      } catch (e) { commit('SET_ERROR', 'Erreur formations'); throw e }
      finally { commit('SET_LOADING', false) }
    },

    async fetchFormationStats({ commit, state, getters }) {
      try {
        const { data } = await axios.get(`${state.apiUrl}admin/formations/stats`, { headers: getters.authHeader })
        commit('SET_FORMATION_STATS', data.data)
      } catch {}
    },

    async saveFormation({ commit, state, getters }, formData) {
      commit('SET_LOADING', true)
      try {
        const id  = formData.get('id')
        const url = id ? `${state.apiUrl}admin/formations/${id}` : `${state.apiUrl}admin/formations`
        if (id) formData.append('_method', 'POST')
        const { data } = await axios.post(url, formData, { headers: getters.authHeader })
        const f = data.data
        if (id) { commit('UPDATE_FORMATION', f); commit('SET_TOAST', 'Formation modifiée') }
        else    { commit('ADD_FORMATION',    f); commit('SET_TOAST', 'Formation créée') }
        return f
      } catch (e) {
        const msg = e.response?.data?.message || 'Erreur sauvegarde'
        commit('SET_ERROR', msg); commit('SET_TOAST', msg); throw e
      } finally { commit('SET_LOADING', false) }
    },

    async deleteFormation({ commit, state, getters }, id) {
      commit('SET_LOADING', true)
      try {
        await axios.delete(`${state.apiUrl}admin/formations/${id}`, { headers: getters.authHeader })
        commit('REMOVE_FORMATION', id); commit('SET_TOAST', 'Formation supprimée')
      } catch (e) { commit('SET_ERROR', 'Erreur suppression'); throw e }
      finally { commit('SET_LOADING', false) }
    },

    // ✅ ACTIONS MANQUANTES AJOUTÉES
    setFormationFilter({ commit, dispatch }, filter) {
      commit('SET_FORMATION_FILTER', filter); commit('SET_FORMATION_PAGE', 1); dispatch('fetchFormations')
    },
    setFormationPage({ commit, dispatch }, page) {
      commit('SET_FORMATION_PAGE', page); dispatch('fetchFormations')
    },

    // Formations publiques
    async fetchPublicFormations({ commit, state }, params = {}) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.get(`${state.apiUrl}public/formations`, { params })
        commit('SET_FORMATIONS', {
          formations: data.data,
          pagination: { current_page:data.current_page, last_page:data.last_page, total:data.total }
        })
        return data
      } catch { } finally { commit('SET_LOADING', false) }
    },

    async fetchFormationBySlug({ commit, state }, slug) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.get(`${state.apiUrl}public/formations/${slug}`)
        commit('SET_CURRENT_FORMATION', data.data); return data
      } catch (e) { commit('SET_ERROR', 'Formation non trouvée'); throw e }
      finally { commit('SET_LOADING', false) }
    },

    async registerToFormation({ commit, state }, { id, formData }) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.post(`${state.apiUrl}public/formations/${id}/register`, formData)
        commit('SET_TOAST', 'Inscription réussie !'); return data
      } catch (e) {
        const msg = e.response?.data?.message || 'Erreur inscription'
        commit('SET_ERROR', msg); commit('SET_TOAST', msg); throw e
      } finally { commit('SET_LOADING', false) }
    },

    // ─── INSCRIPTIONS FORMATIONS ────────────────────────────────────
    async fetchFormationRegistrations({ commit, state, getters }, { formationId, params = {} }) {
      console.log('fetchFormationRegistrations params:', { formationId, ...params })
      commit('SET_LOADING', true); commit('CLEAR_ERROR')
      try {
        const { data } = await axios.get(
          `${state.apiUrl}admin/formations/${formationId}/registrations`,
          {
            headers: getters.authHeader,
            params: {
              page:           state.formationRegistrationsPagination.current_page,
              per_page:       state.formationRegistrationsPagination.per_page,
              ...state.registrationFilters, ...params
            }
          }
        )
        commit('SET_FORMATION_REGISTRATIONS', {
  registrations: data.data.registrations.data, // 👈 IMPORTANT
  formation: data.data.formation,
  pagination: {
    current_page: data.data.registrations.current_page,
    last_page: data.data.registrations.last_page,
    per_page: data.data.registrations.per_page,
    total: data.data.registrations.total
  }
})
        return data
      } catch (e) {
        const msg = e.response?.data?.message || 'Erreur inscriptions'
        commit('SET_ERROR', msg); commit('SET_TOAST', msg); throw e
      } finally { commit('SET_LOADING', false) }
    },

    async updateFormationRegistration({ commit, state, getters }, { id, data }) {
      commit('SET_LOADING', true)
      try {
        const { data: res } = await axios.put(`${state.apiUrl}admin/formations/registrations/${id}`, data, { headers: getters.authHeader })
        commit('UPDATE_REGISTRATION', res.data); commit('SET_TOAST', 'Inscription mise à jour')
        return res
      } catch (e) {
        const msg = e.response?.data?.message || 'Erreur mise à jour'
        commit('SET_ERROR', msg); commit('SET_TOAST', msg); throw e
      } finally { commit('SET_LOADING', false) }
    },

    async deleteFormationRegistration({ commit, state, getters }, id) {
      commit('SET_LOADING', true)
      try {
        await axios.delete(`${state.apiUrl}admin/formations/registrations/${id}`, { headers: getters.authHeader })
        commit('REMOVE_REGISTRATION', id); commit('SET_TOAST', 'Inscription supprimée')
      } catch (e) { commit('SET_ERROR', 'Erreur suppression'); throw e }
      finally { commit('SET_LOADING', false) }
    },

    async fetchRegistrationStats({ commit, state, getters }, formationId) {
      try {
        const { data } = await axios.get(`${state.apiUrl}admin/formations/${formationId}/registrations/stats`, { headers: getters.authHeader })
        commit('SET_REGISTRATION_STATS', data.data)
      } catch {}
    },

    async confirmRegistration({ dispatch }, id) {
      await dispatch('updateFormationRegistration', { id, data: { status: 'confirmé' } })
    },
    async cancelRegistration({ dispatch }, id) {
      await dispatch('updateFormationRegistration', { id, data: { status: 'annulé' } })
    },
    async completeRegistration({ dispatch }, id) {
      await dispatch('updateFormationRegistration', { id, data: { status: 'terminé' } })
    },

    async exportRegistrations({ state, getters }, formationId) {
      const { data } = await axios.get(`${state.apiUrl}admin/formations/${formationId}/registrations/export`, {
        headers: getters.authHeader, responseType: 'blob'
      })
      const url = window.URL.createObjectURL(new Blob([data]))
      const a = document.createElement('a'); a.href = url
      a.download = `inscriptions_${formationId}_${new Date().toISOString().split('T')[0]}.csv`
      document.body.appendChild(a); a.click(); a.remove()
    },

    setRegistrationFilter({ commit }, filter) { commit('SET_REGISTRATION_FILTER', filter); commit('SET_REGISTRATION_PAGE', 1) },
    setRegistrationPage({ commit }, page)      { commit('SET_REGISTRATION_PAGE', page) },
    resetRegistrationFilters({ commit }) {
      ['search','status','payment_status','date_from','date_to'].forEach(k => commit('SET_REGISTRATION_FILTER', { key:k, value:'' }))
      commit('SET_REGISTRATION_PAGE', 1)
    },

    // ─── PROJETS ────────────────────────────────────────────────────
    async fetchProjects({ commit, state, getters }) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.get(`${state.apiUrl}admin/projects`, {
          headers: getters.authHeader,
          params: {
            page:     state.projectsPagination.current_page,
            per_page: state.projectsPagination.per_page,
            ...state.projectFilters
          }
        })
        commit('SET_PROJECTS', {
          projects:   data.data,
          pagination: { current_page:data.current_page, last_page:data.last_page, per_page:data.per_page, total:data.total }
        })
        return data
      } catch (e) { commit('SET_ERROR', 'Erreur projets'); throw e }
      finally { commit('SET_LOADING', false) }
    },

    async fetchProjectStats({ commit, state, getters }) {
      try {
        const { data } = await axios.get(`${state.apiUrl}admin/projects/stats`, { headers: getters.authHeader })
        commit('SET_PROJECT_STATS', data.data)
      } catch {}
    },

    async saveProject({ commit, state, getters }, formData) {
      commit('SET_LOADING', true)
      try {
        const id  = formData.get('id')
        const url = id ? `${state.apiUrl}admin/projects/${id}` : `${state.apiUrl}admin/projects`
        if (id) formData.append('_method', 'POST')
        const { data } = await axios.post(url, formData, { headers: getters.authHeader })
        const p = data.data
        if (id) { commit('UPDATE_PROJECT', p); commit('SET_TOAST', 'Projet modifié') }
        else    { commit('ADD_PROJECT',    p); commit('SET_TOAST', 'Projet créé') }
        return p
      } catch (e) {
        const msg = e.response?.data?.message || 'Erreur sauvegarde'
        commit('SET_ERROR', msg); commit('SET_TOAST', msg); throw e
      } finally { commit('SET_LOADING', false) }
    },

    async deleteProject({ commit, state, getters }, id) {
      commit('SET_LOADING', true)
      try {
        await axios.delete(`${state.apiUrl}admin/projects/${id}`, { headers: getters.authHeader })
        commit('REMOVE_PROJECT', id); commit('SET_TOAST', 'Projet supprimé')
      } catch (e) { commit('SET_ERROR', 'Erreur suppression'); throw e }
      finally { commit('SET_LOADING', false) }
    },

    async updateProjectProgress({ commit, state, getters }, { id, progress }) {
      const { data } = await axios.patch(`${state.apiUrl}admin/projects/${id}/progress`, { progress }, { headers: getters.authHeader })
      commit('UPDATE_PROJECT', data.data); commit('SET_TOAST', `Progression : ${progress}%`)
      return data
    },

    // ✅ ACTIONS MANQUANTES AJOUTÉES
    setProjectFilter({ commit, dispatch }, filter) {
      commit('SET_PROJECT_FILTER', filter); commit('SET_PROJECT_PAGE', 1); dispatch('fetchProjects')
    },
    setProjectPage({ commit, dispatch }, page) {
      commit('SET_PROJECT_PAGE', page); dispatch('fetchProjects')
    },

    // Projets publics
    async fetchPublicProjects({ commit, state }, params = {}) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.get(`${state.apiUrl}public/projects`, { params })
        commit('SET_PROJECTS', {
          projects:   data.data,
          pagination: { current_page:data.current_page, last_page:data.last_page, total:data.total }
        })
        return data
      } catch { } finally { commit('SET_LOADING', false) }
    },

    async fetchFeaturedProject({ commit, state }) {
      try {
        const { data } = await axios.get(`${state.apiUrl}public/projects/featured`)
        commit('SET_FEATURED_PROJECT', data.data)
      } catch {}
    },

    async fetchProjectBySlug({ commit, state }, slug) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.get(`${state.apiUrl}public/projects/${slug}`)
        commit('SET_CURRENT_PROJECT', data.data.project)
        commit('SET_RELATED_PROJECTS', data.data.related)
        return data
      } catch (e) { commit('SET_ERROR', 'Projet non trouvé'); throw e }
      finally { commit('SET_LOADING', false) }
    },

    // ─── ASSOCIATIONS ───────────────────────────────────────────────
    async fetchAssociations({ commit, state, getters }) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.get(`${state.apiUrl}admin/associations`, {
          headers: getters.authHeader,
          params: {
            page:     state.associationsPagination.current_page,
            per_page: state.associationsPagination.per_page,
            ...state.associationFilters
          }
        })
        commit('SET_ASSOCIATIONS', {
          associations: data.data,
          pagination:   { current_page:data.current_page, last_page:data.last_page, per_page:data.per_page, total:data.total }
        })
        return data
      } catch (e) { commit('SET_ERROR', 'Erreur associations'); throw e }
      finally { commit('SET_LOADING', false) }
    },

    async fetchAssociationStats({ commit, state, getters }) {
      try {
        const { data } = await axios.get(`${state.apiUrl}admin/associations/stats`, { headers: getters.authHeader })
        commit('SET_ASSOCIATION_STATS', data.data)
      } catch {}
    },

    async fetchAssociationCategories({ commit, state }) {
      try {
        const { data } = await axios.get(`${state.apiUrl}public/associations/categories`)
        commit('SET_ASSOCIATION_CATEGORIES', data.data)
      } catch {}
    },

    async saveAssociation({ commit, state, getters }, formData) {
      commit('SET_LOADING', true)
      try {
        const id  = formData.get('id')
        const url = id ? `${state.apiUrl}admin/associations/${id}` : `${state.apiUrl}admin/associations`
        if (id) formData.append('_method', 'POST')
        const { data } = await axios.post(url, formData, { headers: getters.authHeader })
        const a = data.data
        if (id) { commit('UPDATE_ASSOCIATION', a); commit('SET_TOAST', 'Association modifiée') }
        else    { commit('ADD_ASSOCIATION',    a); commit('SET_TOAST', 'Association créée') }
        return a
      } catch (e) {
        const msg = e.response?.data?.message || 'Erreur sauvegarde'
        commit('SET_ERROR', msg); commit('SET_TOAST', msg); throw e
      } finally { commit('SET_LOADING', false) }
    },

    async deleteAssociation({ commit, state, getters }, id) {
      commit('SET_LOADING', true)
      try {
        await axios.delete(`${state.apiUrl}admin/associations/${id}`, { headers: getters.authHeader })
        commit('REMOVE_ASSOCIATION', id); commit('SET_TOAST', 'Association supprimée')
      } catch (e) { commit('SET_ERROR', 'Erreur suppression'); throw e }
      finally { commit('SET_LOADING', false) }
    },

    // ✅ ACTIONS MANQUANTES AJOUTÉES
    setAssociationFilter({ commit, dispatch }, filter) {
      commit('SET_ASSOCIATION_FILTER', filter); commit('SET_ASSOCIATION_PAGE', 1); dispatch('fetchAssociations')
    },
    setAssociationPage({ commit, dispatch }, page) {
      commit('SET_ASSOCIATION_PAGE', page); dispatch('fetchAssociations')
    },

    // Associations publiques
    async fetchPublicAssociations({ commit, state }, params = {}) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.get(`${state.apiUrl}public/associations`, { params })
        commit('SET_ASSOCIATIONS', {
          associations: data.data,
          pagination:   { current_page:data.current_page, last_page:data.last_page, total:data.total }
        })
        return data
      } catch { } finally { commit('SET_LOADING', false) }
    },

    async fetchAssociationBySlug({ commit, state }, slug) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.get(`${state.apiUrl}public/associations/${slug}`)
        commit('SET_CURRENT_ASSOCIATION', data.data.association)
        commit('SET_SIMILAR_ASSOCIATIONS', data.data.similar || [])
        return data
      } catch (e) { commit('SET_ERROR', 'Association non trouvée'); throw e }
      finally { commit('SET_LOADING', false) }
    },

    async fetchFeaturedAssociations({ commit, state }) {
      try {
        const { data } = await axios.get(`${state.apiUrl}public/associations/featured`)
        commit('SET_FEATURED_ASSOCIATIONS', data.data)
      } catch {}
    },

    // ─── CONTACTS ───────────────────────────────────────────────────
    async fetchContacts({ commit, state, getters }) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.get(`${state.apiUrl}admin/contacts`, {
          headers: getters.authHeader,
          params: {
            page:     state.contactsPagination.current_page,
            per_page: state.contactsPagination.per_page,
            ...state.contactFilters
          }
        })
        commit('SET_CONTACTS', {
          contacts:   data.data,
          pagination: { current_page:data.current_page, last_page:data.last_page, per_page:data.per_page, total:data.total }
        })
        return data
      } catch (e) { commit('SET_ERROR', 'Erreur contacts'); throw e }
      finally { commit('SET_LOADING', false) }
    },

    async fetchContactStats({ commit, state, getters }) {
      try {
        const { data } = await axios.get(`${state.apiUrl}admin/contacts/stats`, { headers: getters.authHeader })
        commit('SET_CONTACT_STATS', data.data)
      } catch {}
    },

    async fetchContact({ commit, state, getters }, id) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.get(`${state.apiUrl}admin/contacts/${id}`, { headers: getters.authHeader })
        commit('SET_CURRENT_CONTACT', data.data); return data
      } catch (e) { commit('SET_ERROR', 'Erreur chargement contact'); throw e }
      finally { commit('SET_LOADING', false) }
    },

    async updateContact({ commit, state, getters }, { id, data }) {
      commit('SET_LOADING', true)
      try {
        const { data: res } = await axios.post(`${state.apiUrl}admin/contacts/${id}`, data, { headers: getters.authHeader })
        commit('UPDATE_CONTACT', res.data); commit('SET_TOAST', 'Contact mis à jour')
        return res
      } catch (e) {
        const msg = e.response?.data?.message || 'Erreur mise à jour'
        commit('SET_ERROR', msg); commit('SET_TOAST', msg); throw e
      } finally { commit('SET_LOADING', false) }
    },

    async deleteContact({ commit, state, getters }, id) {
      commit('SET_LOADING', true)
      try {
        await axios.delete(`${state.apiUrl}admin/contacts/${id}`, { headers: getters.authHeader })
        commit('REMOVE_CONTACT', id); commit('SET_TOAST', 'Contact supprimé')
      } catch (e) { commit('SET_ERROR', 'Erreur suppression'); throw e }
      finally { commit('SET_LOADING', false) }
    },

    // ✅ ACTION MANQUANTE AJOUTÉE
    setContactPage({ commit, dispatch }, page) {
      commit('SET_CONTACT_PAGE', page); dispatch('fetchContacts')
    },

    async submitContact({ commit, state }, formData) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.post(`${state.apiUrl}public/contacts`, formData)
        commit('SET_TOAST', data.message); return data
      } catch (e) {
        const msg = e.response?.data?.message || 'Erreur lors de l\'envoi'
        commit('SET_ERROR', msg); commit('SET_TOAST', msg); throw e
      } finally { commit('SET_LOADING', false) }
    },

    // ─── DONS ────────────────────────────────────────────────────────
    async fetchDonations({ commit, state, getters }, params = {}) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.get(`${state.apiUrl}admin/donations`, {
          headers: getters.authHeader,
          params: {
            page:     state.donationsPagination.current_page,
            per_page: state.donationsPagination.per_page,
            ...params
          }
        })
        commit('SET_DONATIONS', {
          donations:  data.data,
          pagination: { current_page:data.current_page, last_page:data.last_page, per_page:data.per_page, total:data.total }
        })
        return data
      } catch (e) { commit('SET_ERROR', 'Erreur dons'); throw e }
      finally { commit('SET_LOADING', false) }
    },

    async fetchDonationStats({ commit, state, getters }) {
      try {
        const { data } = await axios.get(`${state.apiUrl}admin/donations/stats`, { headers: getters.authHeader })
        commit('SET_DONATION_STATS', data.data)
      } catch {}
    },

    async confirmDonation({ commit, state, getters, dispatch }, id) {
      const { data } = await axios.patch(`${state.apiUrl}admin/donations/${id}/confirm`, {}, { headers: getters.authHeader })
      commit('UPDATE_DONATION', data.data); commit('SET_TOAST', 'Don confirmé')
      await dispatch('fetchDonationStats')
      return data
    },

    async markReceiptSent({ commit, state, getters }, id) {
      const { data } = await axios.patch(`${state.apiUrl}admin/donations/${id}/receipt`, {}, { headers: getters.authHeader })
      commit('UPDATE_DONATION', data.data); commit('SET_TOAST', 'Reçu marqué envoyé')
      return data
    },

    async deleteDonation({ commit, state, getters }, id) {
      commit('SET_LOADING', true)
      try {
        await axios.delete(`${state.apiUrl}admin/donations/${id}`, { headers: getters.authHeader })
        commit('REMOVE_DONATION', id); commit('SET_TOAST', 'Don supprimé')
      } catch (e) { commit('SET_ERROR', 'Erreur suppression'); throw e }
      finally { commit('SET_LOADING', false) }
    },

    async fetchDonationProjects({ commit, state }) {
      try {
        const { data } = await axios.get(`${state.apiUrl}public/donations/projects`)
        commit('SET_DONATION_PROJECTS', data.data)
      } catch {}
    },

    async createDonation({ commit, state }, donationData) {
      commit('SET_LOADING', true)
      try {
        const fd = new FormData()
        Object.entries(donationData).forEach(([k,v]) => { if(v!=null)fd.append(k,v) })
        const { data } = await axios.post(`${state.apiUrl}public/donations`, fd)
        commit('ADD_DONATION', data.data.donation); commit('SET_TOAST', 'Merci pour votre générosité !')
        return data
      } catch (e) {
        const msg = e.response?.data?.message || 'Erreur lors du don'
        commit('SET_ERROR', msg); commit('SET_TOAST', msg); throw e
      } finally { commit('SET_LOADING', false) }
    },

    async fetchPublicDonationStats({ commit, state }) {
      try {
        const { data } = await axios.get(`${state.apiUrl}public/donations/stats`)
        commit('SET_DONATION_STATS', data.data)
      } catch {}
    },

    // ─── ÉQUIPE ──────────────────────────────────────────────────────
    async fetchTeamMembers({ commit, state, getters }) {
      commit('SET_LOADING', true); commit('CLEAR_ERROR')
      try {
        const { data } = await axios.get(`${state.apiUrl}admin/team-members`, {
          headers: getters.authHeader,
          params: {
            page:     state.teamMembersPagination.current_page,
            per_page: state.teamMembersPagination.per_page,
            ...state.teamMemberFilters
          }
        })
        commit('SET_TEAM_MEMBERS', {
          members:    data.data,
          pagination: { current_page:data.current_page, last_page:data.last_page, per_page:data.per_page, total:data.total }
        })
        return data
      } catch (e) {
        const msg = e.response?.data?.message || 'Erreur membres'
        commit('SET_ERROR', msg); commit('SET_TOAST', msg); throw e
      } finally { commit('SET_LOADING', false) }
    },

    async fetchPublicTeamMembers({ commit, state }) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.get(`${state.apiUrl}public/team-members`, {
          params: { ...state.teamMemberFilters }
        })
        commit('SET_TEAM_MEMBERS', {
          members:    data.data,
          pagination: { current_page:data.current_page, last_page:data.last_page, per_page:data.per_page, total:data.total }
        })
        return data
      } catch { } finally { commit('SET_LOADING', false) }
    },

    async fetchTeamMemberStats({ commit, state, getters }) {
      try {
        const { data } = await axios.get(`${state.apiUrl}admin/team-members/stats`, { headers: getters.authHeader })
        commit('SET_TEAM_MEMBER_STATS', data.data)
      } catch {}
    },

    async fetchTeamMemberDepartments({ commit, state }) {
      try {
        const { data } = await axios.get(`${state.apiUrl}public/team-members/departments`)
        commit('SET_TEAM_MEMBER_DEPARTMENTS', data.data)
      } catch {}
    },

    async saveTeamMember({ commit, state, getters }, formData) {
      commit('SET_LOADING', true); commit('CLEAR_ERROR')
      try {
        const id  = formData.get('id')
        const url = id ? `${state.apiUrl}admin/team-members/${id}` : `${state.apiUrl}admin/team-members`
        if (id) formData.append('_method', 'POST')
        const { data } = await axios.post(url, formData, {
          headers: { ...getters.authHeader, 'Content-Type': 'multipart/form-data' }
        })
        const m = data.data
        if (id) { commit('UPDATE_TEAM_MEMBER', m); commit('SET_TOAST', 'Membre modifié') }
        else    { commit('ADD_TEAM_MEMBER',    m); commit('SET_TOAST', 'Membre créé') }
        return m
      } catch (e) {
        const msg = e.response?.data?.message || 'Erreur sauvegarde'
        commit('SET_ERROR', msg); commit('SET_TOAST', msg); throw e
      } finally { commit('SET_LOADING', false) }
    },

    async deleteTeamMember({ commit, state, getters }, id) {
      commit('SET_LOADING', true)
      try {
        await axios.delete(`${state.apiUrl}admin/team-members/${id}`, { headers: getters.authHeader })
        commit('REMOVE_TEAM_MEMBER', id); commit('SET_TOAST', 'Membre supprimé')
      } catch (e) { commit('SET_ERROR', 'Erreur suppression'); throw e }
      finally { commit('SET_LOADING', false) }
    },

    async reorderTeamMembers({ commit, state, getters }, orderedIds) {
      commit('SET_LOADING', true)
      try {
        await axios.post(`${state.apiUrl}admin/team-members/reorder`,
          { order: orderedIds.map((id,i) => ({ id, order:i })) },
          { headers: getters.authHeader }
        )
        commit('SET_TOAST', 'Ordre mis à jour')
      } catch (e) { commit('SET_ERROR', 'Erreur reorder'); throw e }
      finally { commit('SET_LOADING', false) }
    },

    setTeamMemberFilter({ commit, dispatch }, filter) {
      commit('SET_TEAM_MEMBER_FILTER', filter); commit('SET_TEAM_MEMBER_PAGE', 1); dispatch('fetchTeamMembers')
    },
    setTeamMemberPage({ commit, dispatch }, page) {
      commit('SET_TEAM_MEMBER_PAGE', page); dispatch('fetchTeamMembers')
    },
    resetTeamMemberFilters({ commit, dispatch }) {
      commit('RESET_TEAM_MEMBER_FILTERS'); commit('SET_TEAM_MEMBER_PAGE', 1); dispatch('fetchTeamMembers')
    },

    // ─── ACTIVITÉS RÉCENTES ──────────────────────────────────────────
    async fetchRecentActivities({ commit, state, getters }) {
      try {
        const headers = getters.authHeader
        const opts    = p => ({ headers, params: { per_page:5, sort_by:'created_at', ...p } })
        const [don, form, proj, cont, art] = await Promise.all([
          axios.get(`${state.apiUrl}admin/donations`,  opts()),
          axios.get(`${state.apiUrl}admin/formations`, opts()),
          axios.get(`${state.apiUrl}admin/projects`,   opts()),
          axios.get(`${state.apiUrl}admin/contacts`,   opts()),
          axios.get(`${state.apiUrl}admin/articles`,   opts()),
        ])

        const activities = []
        const fmtTime = d => {
          const diff = Date.now() - new Date(d)
          const m = Math.floor(diff/60000)
          if (m < 1)  return 'À l\'instant'
          if (m < 60) return `Il y a ${m} min`
          const h = Math.floor(m/60)
          if (h < 24) return `Il y a ${h} h`
          const j = Math.floor(h/24)
          if (j < 7)  return `Il y a ${j} jour${j>1?'s':''}`
          return new Date(d).toLocaleDateString('fr-FR')
        }

        don.data.data?.forEach(d  => activities.push({ type:'don',      message:`Don de ${d.amount}€ — ${d.donor_name||'Anonyme'}`,                  time:fmtTime(d.created_at),                   data:d }))
        form.data.data?.forEach(f => activities.push({ type:'formation', message:`Formation "${f.title}" ${f.status==='upcoming'?'programmée':'active'}`, time:fmtTime(f.created_at),                   data:f }))
        proj.data.data?.forEach(p => activities.push({ type:'projet',    message:`Projet "${p.title}" (${p.progress||0}% achevé)`,                     time:fmtTime(p.updated_at||p.created_at),      data:p }))
        cont.data.data?.forEach(c => activities.push({ type:'contact',   message:`Nouveau message de ${c.full_name||c.first_name}`,                    time:fmtTime(c.created_at),                   data:c }))
        art.data.data?.forEach(a  => activities.push({ type:'article',   message:`Article "${a.title}" publié`,                                        time:fmtTime(a.published_at||a.created_at),   data:a }))

        const sorted = activities
          .sort((a,b) => new Date(b.data.created_at) - new Date(a.data.created_at))
          .slice(0, 10)

        commit('SET_RECENT_ACTIVITIES', sorted)
      } catch (e) { console.error('fetchRecentActivities:', e) }
    },
  },

  modules: {}
})